var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.291,
    height: 20.229,
    viewBox: "0 0 20.291 20.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "translate(0.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M8.746,0V1.249A6.166,6.166,0,0,0,3.909,7.243v5.388L-.073,16.074v.937H20.217v-.937l-3.982-3.443V7.243A6.166,6.166,0,0,0,11.4,1.249V0Zm1.326,17.272a1.479,1.479,0,1,0,1.479,1.478A1.478,1.478,0,0,0,10.072,17.272Z",
    fill: "#383838"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.a0ddb68f9e43fb182dfc3f8fc78b5ca6.svg";
export { ForwardRef as ReactComponent };